import { Help } from '@mui/icons-material';
import { Box, MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { menuItemLayout } from '../../common/popover/userPopover/userPopoverStyles';

const HELP_MAPPING: { regex: RegExp; path: string }[] = [
  {
    regex: /-templates\//,
    path: '/automations-and-integrations/using-templates',
  },
  {
    regex: /^\/accounts/,
    path: '/core-features/managing-clients',
  },
  {
    regex: /^\/events/,
    path: '/core-features/scheduling-events',
  },
  {
    regex: /^\/tasks/,
    path: '/core-features/managing-tasks',
  },
];

export default function HelpLink() {
  const location = useLocation();
  const linkFromPath = () => {
    const urlMatch = _.find(HELP_MAPPING, (mappingObj) => !!location.pathname.match(mappingObj.regex));

    return `https://schedulink.gitbook.io/help-center${urlMatch == null ? '' : urlMatch.path}`;
  };

  return (
    <Box sx={{ height: '100%' }}>
      <MenuItem component="a" href={linkFromPath()} target="_blank" rel="noopener noreferrer" sx={menuItemLayout}>
        <Help color="action" />
        <Typography>Help Center</Typography>
      </MenuItem>
    </Box>
  );
}
